import { render, staticRenderFns } from "./table_relation_setting_dialog.vue?vue&type=template&id=21c38fdf"
import script from "./table_relation_setting_dialog.vue?vue&type=script&lang=js"
export * from "./table_relation_setting_dialog.vue?vue&type=script&lang=js"
import style0 from "./table_relation_setting_dialog.vue?vue&type=style&index=0&id=21c38fdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports